import {MutationTree} from "vuex";

export const mutations: MutationTree<any> = {

    setHelpLoading(state: any, payload: boolean) {
        state.loading = payload;
    },
};
